<template>
  <hi-page>
    <hi-page-column card width="35vw" fix-width gradient-softer gradient-top>
      <hi-row flex class="py-2 sec-title">
        <!--        <HiSimpleDropdown title="Select Projects" label="Projects: ">-->
        <!--          <HiSelectableChips-->
        <!--            :items="computedProjects"-->
        <!--            item-value="id"-->
        <!--            item-text="name"-->
        <!--            item-text-additional="total"-->
        <!--            select-all-->
        <!--          ></HiSelectableChips>-->
        <!--        </HiSimpleDropdown>-->
        <di-project-selector-multiple
          local-id="leads-list"
          @select="selectProjects"
        ></di-project-selector-multiple>

        <v-spacer></v-spacer>
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="openNewLeadsDL()">
              <v-list-item-title>Add New</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openImportDL()">
              <v-list-item-title>Import</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </hi-row>
      <hi-row grow :px="0" class="sec-title">
        <leads-list
          @select="selectItem"
          :projects="selectedProjects"
        ></leads-list>
      </hi-row>
    </hi-page-column>
    <router-view class="flex-grow-1"></router-view>
    <template v-if="!$route.params.id">
      <Leads_Root></Leads_Root>
    </template>
    <d-l-new-lead ref="DLNewLead"></d-l-new-lead>
    <HiCSVLoader ref="DLCsvLoader"></HiCSVLoader>
  </hi-page>
</template>
<script>
import HiPage from "@/components/scaffold/HiPage";
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import HiRow from "@/components/scaffold/HiRow";
import { db, docs, rtDb } from "@/db";
// import HiSimpleDropdown from "@/components/HiSimpleDropdown";
// import HiSelectableChips from "@/components/HiSelectableChips";

// import Formatter from "@/hive/Formatter";
import LeadsList from "@/components/leads/LeadsList";
import DLNewLead from "@/components/leads/DLNewLead";
import HiCSVLoader from "@/components/HiCSVLoader";
// import Leads_ID from "@/pages/Leads_ID";
import Leads_Root from "@/pages/Leads_Root";
import DiProjectSelectorMultiple from "@/components/DiProjectSelectorMultiple";
// import HiIcon from "@/components/HiIcon";
// import Formatter from "@/hive/Formatter";

export default {
  name: "Leads",
  components: {
    DiProjectSelectorMultiple,
    DLNewLead,
    HiCSVLoader,
    HiPageColumn,
    HiPage,
    HiRow,
    // HiSimpleDropdown,
    // HiSelectableChips,
    LeadsList,
    // Leads_ID,
    Leads_Root
    // LeadDetails,
    // LeadComments
  },
  created() {},
  destroyed() {},
  data() {
    return {
      openNewLeads: false,
      projects: [],
      selectedProjects: "all",
      leadCounters: {},
      comments: [],
      leadLabels: docs.leadLabels
    };
  },
  // computed: {
  //   computedProjects() {
  //     if (this.leadCounters && this.leadCounters.total) {
  //       return Object.keys(this.projects).map(key => ({
  //         id: key,
  //         name: this.projects[key].name,
  //         total: 0
  //       }));
  //     }
  //     return [];
  //   }
  // },
  firebase: {
    projects: rtDb.ref("_meta/projects")
  },
  firestore: {
    leadCounters: db.doc("_counters/leads")
  },
  methods: {
    openNewLeadsDL() {
      this.$refs.DLNewLead.open();
    },
    openImportDL() {
      this.$refs.DLCsvLoader.open();
    },
    selectItem(item) {
      console.log(item);
      this.$router.replace({ path: `/leads/${item.id}` });
    },
    selectProjects(val) {
      this.selectedProjects = val;
    }
  }
};
</script>
<style lang="scss" scoped></style>
